import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-down"><path d="M4.3931 15.0982C3.69536 14.2879 4.27103 13.0325 5.34031 13.0325H7.99992V3.78251C7.99992 2.81601 8.78342 2.03251 9.74992 2.03251H14.2499C15.2164 2.03251 15.9999 2.81602 15.9999 3.78251V13.0325H18.6595C19.7288 13.0325 20.3045 14.2879 19.6067 15.0982L13.326 22.3919C12.6278 23.2027 11.372 23.2027 10.6738 22.3919L4.3931 15.0982Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathDown;
